import type { CSSProperties } from 'react'
import { Button } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { cn } from '@/shared/lib'
import { typographyStyle } from '@/shared/lib/catalog'

export type OnboardingFloatingCtaProps = {
  className?: string
  onPrimaryClick?: () => void
  onSecondaryClick?: () => void
}

const floatingTokens = designTokens.components.choosePlan.mobile.floatingCta
const secondaryTypography = designTokens.typography.body.base

const secondaryStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.primary,
  opacity: Number(designTokens.components.onboarding.mobile.textButtonOpacity),
  ...typographyStyle(secondaryTypography),
}

export function OnboardingFloatingCta({
  className,
  onPrimaryClick,
  onSecondaryClick,
}: OnboardingFloatingCtaProps) {
  const containerStyle: CSSProperties = {
    background: floatingTokens.background,
    boxShadow: floatingTokens.shadow,
    backdropFilter: `blur(${floatingTokens.blur})`,
    WebkitBackdropFilter: `blur(${floatingTokens.blur})`,
    padding: `${floatingTokens.paddingTop} ${floatingTokens.paddingX} ${floatingTokens.paddingBottom}`,
    gap: floatingTokens.gap,
  }

  return (
    <div className={cn('flex w-full flex-col', className)} style={containerStyle}>
      <Button variant="primaryMobile" onClick={onPrimaryClick}>
        Активировать подписку
      </Button>
      <button type="button" className="w-full" style={secondaryStyle} onClick={onSecondaryClick}>
        Перейти в личный кабинет
      </button>
    </div>
  )
}
